module.exports = __webpack_public_path__ + "img/logo-large.67368d1.svg";